<template>
  <vx-card no-shadow>
    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-input v-if="question" label="" placeholder="Title..." :content.sync="question.title" class="w-full" />
      </div>
    </div>

    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Help text</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-textarea v-if="question" placeholder="Help Text..." :content.sync="question.helpText" class="w-full" />
      </div>
    </div>

    <h5 class="mb-3">Experience Points</h5>
    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Configure how many points the participants will earn when answering correctly to the question</span>
      </div>
      <div class="vx-col">
        <vs-input v-if="question" v-validate="'numeric'" name="points" v-model="question.points" />
        <div v-if="question" class="text-danger text-sm" v-show="errors.has('points')">{{ errors.first('points') }}</div>
      </div>
    </div>
    
    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <TypedSurveyImages v-if="question" 
      :item="question" 
      :assetUrl="this.surveyType + '/' + this.surveyId + '?moduleId=' + this.moduleId + '&lessonId=' + this.lessonId + '&questionId=' + this.questionId"
      style="width: 100%;" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>

const TypedSurveyImages = () => import("./../TypedSurveyImages.vue");

export default {
  components: {
    TypedSurveyImages
  },
  props: {
    question: Object
  },
  data () {
    return {
      surveyType: '',
      surveyId: '',
      moduleId: '',
      lessonId: '',
      questionId: '',
      
      name: ''
    }
  },
  methods: {
    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      const payload = {
        title: this.question.title,
        helpText: this.question.helpText,
        points: parseInt(this.question.points),
        allCorrectToPass: this.question.allCorrectToPass
      }

      this.$http.put(process.env.VUE_APP_API +'/Surveys/' + this.surveyType + '/' + this.surveyId + '/modules/' + this.moduleId + '/lessons/' + this.lessonId + '/questions/' + this.questionId + '/info/general', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Question saved'
            });
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save question: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.surveyType = this.$route.params.surveyType;
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
    this.lessonId = this.$route.params.lessonId;
    this.questionId = this.$route.params.questionId;
  }
}
</script>
